module.exports = __webpack_public_path__ + "img/success_popup_bg.e2c00885.png";